import { render, staticRenderFns } from "./YiLianKKAuth.vue?vue&type=template&id=abd02114&scoped=true"
import script from "./YiLianKKAuth.vue?vue&type=script&lang=js"
export * from "./YiLianKKAuth.vue?vue&type=script&lang=js"
import style0 from "./YiLianKKAuth.vue?vue&type=style&index=0&id=abd02114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd02114",
  null
  
)

export default component.exports